import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ReferralHash from "../../../common/referral-hash";

import parlor from "assets/graphics/icons/parlor.svg";

import "features/application/header/view.scss";

const HeaderView = ({ userData, signOut }) => (
  <header className="application__header">
    <Link
      to={
        "/" + (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
      }
      onClick={() => window.dataLayer.push({ event: "homeVisited" })}
    >
      <img src={parlor} alt="parlor" />
    </Link>
    {userData && (
      <button type="button" onClick={signOut}>
        Sign out
      </button>
    )}
  </header>
);

HeaderView.propTypes = {
  userData: PropTypes.object,
  signOut: PropTypes.func,
};

export default HeaderView;
